import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getUserAccountStatus, getUserPortalUrl, getUserRole } from "~/shared/auth-utils";
import { wrapArray } from "./utils";

/**
 * @typedef {"Active" | "Deactivated" | "Onboarding Pending" | "Invite Sent" | "Profile Setup Complete" | "Photo Video Form Pending" | "Household Setup Pending" | "Registration Pending" | "Parent Setup Pending"} AccountStatus
 * @param {Object} props
 * @param {"ADMIN" | "STAFF" | "FAMILY"} props.role
 * @param {AccountStatus | AccountStatus[]} props.status
 */
export function AuthenticatedRoute({ component: Component, role, status, ...rest }) {
    function render() {
        if (getUserRole() !== role) {
            return <Redirect to={getUserPortalUrl(role)} />;
        }

        if (status && !wrapArray(status).includes(getUserAccountStatus())) {
            return redirectUserIfNeeded() ?? <Component />;
        }

        return <Component />;
    }

    return <Route {...rest} render={render} />;
}

/**
 * @param {Object} props
 * @param {"ADMIN" | "STAFF" | "FAMILY"} props.role
 */
export function PublicRoute({ component: Component, ...rest }) {
    return <Route {...rest} render={() => redirectUserIfNeeded() ?? <Component />} />;
}

function redirectUserIfNeeded() {
    if (getUserRole() === "FAMILY") {
        // Link to profile setup pages if setup is not complete
        return <Redirect to={{
            "Parent Setup Pending": "/setup/parent",
            "Household Setup Pending": "/setup/household",
            "Photo Video Form Pending": "/photo-video-form"
        }[getUserAccountStatus()] ?? "/home"} />;
    }
    else if (getUserRole() === "ADMIN") {
        return <Redirect to="/admin/dashboard" />;
    }
    else if (getUserRole() === "STAFF") {
        if (getUserAccountStatus() && !["Active", "Onboarding Pending"].includes(getUserAccountStatus())) {
            return <Redirect to="/register-staff" />;
        }

        return <Redirect to="/staff/dashboard" />;
    }
}